import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Survey from '../../services/survey';
import Fb from '../../assets/images/fb.svg';
import Yt from '../../assets/images/yt.svg';
import Web from '../../assets/images/web.png';
import './style.scss';

const Footer = () => {
  const [footer, setFooter] = useState();
  useEffect(() => {
    Survey.getFooter().then(response => {
      setFooter(response);
    });
  }, []);
  return (
    <footer className="new_footer_area bg_color">
      <div className="new_footer_top">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="f_widget company_widget wow fadeInLeft" data-wow-delay="0.2s">
                <h3><Badge variant="primary">Trung Tâm Phát Triển Năng Lực - Đại Học Văn Lang</Badge></h3>
                <span dangerouslySetInnerHTML={{ __html: footer?.systemConfig?.Address }} />
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="f_widget about-widget pl_70 wow fadeInLeft" data-wow-delay="0.6s">
                <h3><Badge variant="success">Công cụ</Badge></h3>
                <ul className="list-unstyled f_list">
                  {footer?.surveys.map(survey => (
                    <li key={survey.id}><Link to={survey?.slug}>{survey?.title}</Link></li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="f_widget social-widget pl_70 wow fadeInLeft" data-wow-delay="0.8s">
                <h3><Badge variant="danger">Kết nối</Badge></h3>
                <div className="f_social_icon">
                  <a href={footer?.systemConfig?.Facebook} target="_blank" rel="noopener noreferrer">
                    <img src={Fb} alt="Trung Tâm Phát Triển Năng Lực - Đại Học Văn Lang" />
                  </a>
                  <a href={footer?.systemConfig?.Youtube} target="_blank" rel="noopener noreferrer">
                    <img src={Yt} alt="Trung Tâm Phát Triển Năng Lực - Đại Học Văn Lang" />
                  </a>
                  <a href="https://vanlanguni.edu.vn/" target="_blank" rel="noopener noreferrer">
                    <img src={Web} alt="Trung Tâm Phát Triển Năng Lực - Đại Học Văn Lang" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer_bg">
          <div className="footer_bg_one" />
          <div className="footer_bg_two" />
        </div>
      </div>
      <div className="footer_bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12 text-center">
              <p className="info">
                {`Trung Tâm Phát Triển Năng Lực - Trường Đại Học Văn Lang - ${(new Date()).getFullYear()}`}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
